import { EEnvironment, envVars } from '@/config';
import type { Picture } from '@/graphql/gql/graphql';
import { ClientStorage } from './clientStorage';

export function getPictureSrc(picture: Picture): string | null {
  const path = picture?.path256 ?? picture?.path;
  if (!path) return null;
  const savedEnv = ClientStorage.local.getItem<EEnvironment>('ques-envMode') || EEnvironment.PRODUCTION;
  const bucket = savedEnv === EEnvironment.PRODUCTION ? envVars.aws.bucket : envVars.aws.devBucket;
  const prefix = `${envVars.aws.s3Url}/${bucket}`;
  return `${prefix}/${path.replace('images/', '')}`;
}
